var klevu_helpers = {
  // LUXE CUSTOM CONTENT
  luxeContent: function () {
    if (window.klevu__contentHTML != undefined) {
      var items = document.querySelectorAll("#kuLandingProductsListUl > li");
      var count = 0;
      var content = window.klevu__contentHTML;

      var markup = "";
      var contentColour = window.klevu__content.contentColour.toLowerCase();

      markup = content.replace(
        /{{image1}}/,
        JSON.parse(window.klevu__content.image).cloudinary_src + "w_1344"
      );
      markup = markup.replace(
        /{{image2}}/,
        JSON.parse(window.klevu__content.image).cloudinary_src + "w_1344"
      );
      markup = markup.replace(
        /{{imageAlt}}/,
        JSON.parse(window.klevu__content.image).alt
      );

      if (window.klevu__content.content) {
        markup = markup.replace(
          /{{content}}/,
          '<div class="l-grid__item"><h3 class="c-title t-color-' +
            contentColour +
            '">' +
            window.klevu__content.content +
            "</h3></div>"
        );
      } else {
        markup = markup.replace(/{{content}}/, "");
      }
      if (window.klevu__content.linkUrl) {
        markup = markup.replace(
          /{{link}}/,
          '<div class="l-grid__item"><a href="' +
            window.klevu__content.linkUrl +
            '" class="c-btn c-btn--' +
            contentColour +
            '">' +
            window.klevu__content.linkText +
            "</a></div>"
        );
      } else {
        markup = markup.replace(/{{link}}/, "");
      }

      var currentPage = document.querySelector(
        ".kuPagination .kuCurrent"
      ).innerHTML;
      var container = document.createElement("div");
      container.innerHTML = markup;
      container.classList.add("c-hero", "c-collection-content", "is-active");

      if (markup != "" && currentPage == "1") {
        items.forEach(function (item) {
          count = count + 1;
          if (count == 8) {
            item.after(container);
          }
        });
      }
    }
  },
  luxePagination: function () {
    window.onload = function () {
      var body = document.querySelector("body");
      if (body.classList.contains("luxe-page")) {
        var luxePage = true;
        klevu_changeItemsPerPage(21);
      }
    };
  },
  customContentBlock: function () {
    if (window.klevu__customContentHTML != undefined) {
      var blocks = window.klevu__customContentHTML.split("<br />");
      for (let index = 0; index < blocks.length; index++) {
        var items = document.querySelectorAll("#kuLandingProductsListUl > li");
        var count = 0;
        var htmlContent = blocks[index];
        var currentPage = document.querySelector(
          ".kuPagination .kuCurrent"
        ).innerHTML;
        var container = document.createElement("li");
        container.innerHTML = htmlContent;
        container.classList.add("l-grid__item", "custom-block");

        var position = parseFloat(
          container
            .querySelector(".js-custom-block")
            .getAttribute("data-position")
        );
        var desktopSize = parseFloat(
          container
            .querySelector(".js-custom-block")
            .getAttribute("data-desktop-size")
        );

        container.classList.add("custom-block--" + desktopSize);

        if (htmlContent != "" && currentPage == "1") {
          items.forEach(function (item, idx) {
            const index = idx + 1;
            if (index == position) {
              item.before(container);
            }
          });
        }
      }
    }
  },
};

// LUXE Product Count
var luxeProductStart = 3;
var luxeProductCount = 8;

var luxeCount = [
  3, 8, 17, 24, 29, 38, 45, 50, 59, 66, 71, 80, 87, 92, 101, 109,
];

var arrayLength = luxeCount.length;

var klevu_uc = {
  showLandingPageData: function (product) {
    // Are we on a LUXE page?
    var body = document.querySelector("body");
    if (body.classList.contains("luxe-page")) {
      var luxePage = true;
    }

    var toReturn = "",
      toAppendwithSalePrice = "",
      priceWithCurrency = "",
      appendCurrencyAtLast = false,
      salepriceClass = "kuSalePrice",
      priceFormatter,
      priceToSet,
      showToLabel = false,
      additionalParams = "",
      keywords = document.getElementById("searchedKeyword").value,
      trackingParams = "",
      trackingEventHtml = "",
      i = 0,
      j = 0,
      currentSwatch,
      swatchEventHandlerHtml,
      swatchFocusHandler,
      swatchBlurHandler,
      swatchColor,
      swatchCount = 0,
      swatchesShown = false,
      swatchesHtml = "",
      totalSwatchesToShow = 5,
      validSwatch = true,
      swatchGradientCSS = "",
      imgAlt,
      imgAltDiv = document.createElement("div"),
      additionalFlags = product.additionalDataToReturn
        ? JSON.parse(product.additionalDataToReturn)
        : false;

    product = klevu_productCustomizations(product);

    product.additionalFlags = additionalFlags;
    if (product.productImage.trim().length === 0) {
      product.productImage = klevu_userOptions.noImageUrl;
    }

    if (klevu_userOptions.openProductClicksInNewWindow) {
      additionalParams = ' target="_blank"';
    } else {
      additionalParams =
        ' onclick="klevu_analytics.stopClickDefault( event );" target="_self"';
    }
    trackingParams =
      "{" +
      "data: {" +
      "code: '" +
      escape(product.productCode) +
      "'," +
      "url: '" +
      escape(product.productUrl + "?variant=" + product.id) +
      "'," +
      "name: '" +
      escape(product.productName) +
      "'," +
      "salePrice: '" +
      escape(product.salePrice) +
      "'," +
      "rating: '" +
      escape(product.rating) +
      "'," +
      "position: " +
      product.productPosition +
      "," +
      "category: '" +
      escape(product.category) +
      "'," +
      "sku: '" +
      escape(product.sku) +
      "'" +
      "}," +
      "apiKey: null," +
      "keywordsLP: '" +
      escape(keywords) +
      "'" +
      "}";

    if (klevu_commons.isMobileDevice()) {
      trackingEventHtml =
        ' onclick="return klevu_analytics.trackClickedProduct(event, ' +
        trackingParams +
        ');" target="_self">';
    } else {
      trackingEventHtml =
        ' onmousedown="return klevu_analytics.trackClickedProduct(event, ' +
        trackingParams +
        ');" onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' +
        trackingParams +
        ', klevu_analytics.trackClickedProduct);" ' +
        additionalParams +
        ">";
    }
    try {
      // code for the result block
      if (luxePage === true) {
        var luxe = false;
        for (var i = 0; i < arrayLength; i++) {
          var luxePosition = parseFloat(luxeCount[i]);
          var productPosition = parseFloat(product.productPosition);
          if (luxePosition === productPosition) {
            luxe = true;
          }
        }
        if (luxe === true) {
          toReturn += '<li class="l-grid__item luxe-list-item">';
        } else {
          toReturn += '<li class="l-grid__item">';
        }
      } else {
        toReturn += '<li class="l-grid__item">';
      }
      toReturn += '<div class="klevuImgWrap">';
      toReturn +=
        "<a  onfocus=\"klevu_eventHandler.handleProductFocusEvent('kuAddtocart-" +
        escape(product.productCode) +
        "', event);\"" +
        'href="' +
        product.productUrl.replace(/"/g, "%22") +
        "?variant=" +
        product.id +
        '"';
      if (klevu_userOptions.showRolloverImage && product.imageHover) {
        if (luxePage === true) {
          var luxe = false;
          for (var i = 0; i < arrayLength; i++) {
            var luxePosition = parseFloat(luxeCount[i]);
            var productPosition = parseFloat(product.productPosition);
            if (luxePosition === productPosition) {
              luxe = true;
            }
          }
          if (luxe === true) {
            toReturn +=
              " onmouseleave = \"klevu_commons.updateProductThumbnailImage('" +
              escape(product.imageHover) +
              "', 'klevuProductImage-" +
              product.id +
              "');\" " +
              " onmouseenter = \"klevu_commons.updateProductThumbnailImage('" +
              escape(product.productImage) +
              "', 'klevuProductImage-" +
              product.id +
              "');\" ";
          } else {
            toReturn +=
              " onmouseleave = \"klevu_commons.updateProductThumbnailImage('" +
              escape(product.productImage) +
              "', 'klevuProductImage-" +
              product.id +
              "');\" " +
              " onmouseenter = \"klevu_commons.updateProductThumbnailImage('" +
              escape(product.imageHover) +
              "', 'klevuProductImage-" +
              product.id +
              "');\" ";
          }
        } else {
          toReturn +=
            " onmouseleave = \"klevu_commons.updateProductThumbnailImage('" +
            escape(product.productImage) +
            "', 'klevuProductImage-" +
            product.id +
            "');\" " +
            " onmouseenter = \"klevu_commons.updateProductThumbnailImage('" +
            escape(product.imageHover) +
            "', 'klevuProductImage-" +
            product.id +
            "');\" ";
        }
      }
      imgAltDiv.innerHTML = product.productName;
      imgAlt = imgAltDiv.textContent || imgAltDiv.innerText || "";

      if (luxePage === true) {
        var luxe = false;
        for (var i = 0; i < arrayLength; i++) {
          var luxePosition = parseFloat(luxeCount[i]);
          var productPosition = parseFloat(product.productPosition);
          if (luxePosition === productPosition) {
            luxe = true;
          }
        }

        if (luxe === true) {
          toReturn +=
            " " +
            trackingEventHtml +
            '<img id= "klevuProductImage-' +
            product.id +
            '" data-src="' +
            product.imageHover +
            '" onerror="this.onerror=null;this.src=\'' +
            klevu_userOptions.noImageUrl +
            '\';" alt="' +
            klevu_commons.escapeHtml(imgAlt) +
            '" class="u-lazyload js-lazyload" width="328" height="328" />';
        } else {
          toReturn +=
            " " +
            trackingEventHtml +
            '<img id= "klevuProductImage-' +
            product.id +
            '" data-src="' +
            product.productImage +
            '" onerror="this.onerror=null;this.src=\'' +
            klevu_userOptions.noImageUrl +
            '\';" alt="' +
            klevu_commons.escapeHtml(imgAlt) +
            '" class="u-lazyload js-lazyload" width="328" height="328" />';
        }
      } else {
        toReturn +=
          " " +
          trackingEventHtml +
          '<img id= "klevuProductImage-' +
          product.id +
          '" data-src="' +
          product.productImage +
          '" onerror="this.onerror=null;this.src=\'' +
          klevu_userOptions.noImageUrl +
          '\';" alt="' +
          klevu_commons.escapeHtml(imgAlt) +
          '" class="u-lazyload js-lazyload" width="328" height="328" />';
      }

      toReturn += "</a>";
      if (product.badge != undefined && product.badge != "PRE-ORDER") {
        toReturn += '<span class="c-badge">' + product.badge + "</span>";
      }
      toReturn += "</div>"; //closing image wrap
    } catch (e) {}

    if (
      "undefined" !== typeof klevu_showDiscountBadge &&
      klevu_showDiscountBadge &&
      product.discount != "" &&
      product.discount != "0" &&
      product.discount != "0.0"
    ) {
      if (klevu_uiLabels.discountBadgeText.indexOf("#") === -1) {
        toReturn +=
          '<div class="kuDiscountBadge">' +
          klevu_uiLabels.discountBadgeText +
          " " +
          Number(product.discount).toFixed(0) +
          "%</div>";
      } else {
        toReturn +=
          '<div class="kuDiscountBadge">' +
          klevu_uiLabels.discountBadgeText.replace(
            "#",
            Number(product.discount).toFixed(0) + "%"
          ) +
          "</div>";
      }
    }
    if (product.brand_name != undefined) {
      toReturn += '<div class="kuBrandName">' + product.brand_name + '</div>';
    }
    toReturn += '<div class="kuNameDesc">';
    toReturn +=
      '<div class="kuName"><a tabindex="-1" href="' +
      product.productUrl.replace(/"/g, "%22") +
      "?variant=" +
      product.id +
      '"" target="_blank" ' +
    trackingEventHtml;
    toReturn += product.productName + "</a></div>";
    toReturn += '<div class="kuDesc">' + product.productDescription + "</div>";
    toReturn += klevu_landingProductElements.showRating(product);
    toReturn += "</div>";

    toReturn += '<div class="kuPrice">';
    if (klevu_showPrices) {
      toReturn += klevu_landingProductElements.showPrices(
        product,
        salepriceClass
      );
    }

    if (klevu_userOptions.vatCaption.trim().length > 0) {
      toReturn +=
        '<div class="klevu-vat-caption">(' +
        klevu_userOptions.vatCaption +
        ")</div>";
    }

    if (
      product.totalProductVariants &&
      product.totalProductVariants != "0" &&
      !swatchesShown
    ) {
      if (klevu_uiLabels.variants.indexOf("#") === -1) {
        toReturn +=
          '<div class="klevu-variants">+' +
          product.totalProductVariants +
          " " +
          theme.strings.options +
          "</div>";
      } else {
        toReturn +=
          '<div class="klevu-variants">' +
          klevu_uiLabels.variants.replace("#", product.totalProductVariants) +
          "</div>";
      }
    }
    if (klevu_userOptions.outOfStockCaption.trim().length > 0) {
      if (product.inStock && product.inStock === "no") {
        toReturn +=
          '<div class="klevu-out-of-stock">' +
          klevu_userOptions.outOfStockCaption +
          "</div>";
      }
    }

    toReturn += "</div>";

    toReturn += klevu_uc.customSwatches(product);

    if (
      klevu_commons.showAddToCartButton(product.inStock, product.hideAddToCart)
    ) {
      toReturn += klevu_uc.showAddtocart(product);
    }

    toReturn += '<div class="kuClearLeft"></div>';
    toReturn += "</li>";

    return toReturn;
  },
  showAddtocart: function (product) {
    try {
      var toReturn = "",
        additionalFlags = product.additionalFlags,
        buttonLabel = klevu_userOptions.addToCartButton,
        variants = product.totalProductVariants
          ? +product.totalProductVariants
          : 0,
        preorderOnly = false;
      if (additionalFlags) {
        if (additionalFlags.preorder_only) {
          preorderOnly = true;
          buttonLabel = klevu_userOptions.preorderButton;
        }
        if (additionalFlags.purchasing_disabled) {
          if (!preorderOnly) {
            return "";
          }
        }
      }

      if (variants === 0) {
        toReturn +=
          '<div class="kuAddtocart" id="kuAddtocart-' +
          escape(product.productCode) +
          '">' +
          '<label for="klevu-qty-' +
          escape(product.productCode) +
          '" style="display:none;">&nbsp;</label>' +
          '<input tabindex="0" type="text" name="klevu-qty" id="klevu-qty-' +
          escape(product.productCode) +
          '" placeholder="' +
          klevu_uiLabels.addToCartPlaceholder +
          '"/>' +
          "<a href=\"javascript:klevu_lpSendProductToCart('" +
          escape(product.productCode) +
          "', '" +
          escape(product.productUrl) +
          "', 'klevu-qty-" +
          escape(product.productCode) +
          "');\" " +
          'class="kuAddtocartBtn" target="_self" data-add-to-cart data-cart-add="' +
          product.id +
          '">' +
          buttonLabel +
          "</a>";
        ("</div>");
      } else {
        toReturn +=
          '<div class="kuAddtocart" id="kuAddtocart-' +
          escape(product.productCode) +
          '">' +
          '<a href="' +
          product.productUrl.replace(/"/g, "%22") +
          "?variant=" +
          product.id +
          '"' +
          '" class="kuAddtocartBtn" target="_self">View More</a>';
        ("</div>");
      }

      toReturn += '<div class="klevu-clearboth-listview"></div>';
    } catch (e) {}
    return toReturn;
  },

  customSwatches: function (product) {
    try {
      var toReturn = "";
      // CUSTOM SWATCHES
      var productNames = JSON.parse(product.product)[0];
      var productColors = JSON.parse(product.altswatch)[0];
      var currentColor = product.currentswatch
        .replace(/\s+/g, "-")
        .toLowerCase();

      if (typeof productNames !== "undefined") {
        toReturn +=
          '<div class="d-flex u-justify-content-center u-mgn-b-s@xs">';

        if (typeof currentColor !== "undefined") {
          toReturn +=
            '<a href="' +
            product.productUrl +
            '" class="d-block c-variant c-variant--' +
            currentColor +
            '"></a>';
        }

        if (typeof productNames === "object") {
          for (let index = 0; index < productNames.length; index++) {
            const altName = productNames[index];
            const altColor = productColors[index]
              .replace(/\s+/g, "-")
              .toLowerCase();
            toReturn +=
              '<a href="/products/' +
              altName +
              '" class="d-block c-variant c-variant--' +
              altColor +
              '"></a>';
          }
        } else if (typeof productNames === "string") {
          const altName = productNames;
          const altColor = productColors.replace(/\s+/g, "-").toLowerCase();
          toReturn +=
            '<a href="/products/' +
            altName +
            '" class="d-block c-variant c-variant--' +
            altColor +
            '"></a>';
        }

        toReturn += "</div>";
      }
    } catch (e) {}
    return toReturn;
  },
};

function klevu_afterLandingResultsLoaded(results) {
  // LUXE Custom Content
  klevu_helpers.luxeContent();
  // Metafield custom content
  klevu_helpers.customContentBlock();
  // Custom Filter Text
  var narrowText = document.querySelector(".KuFilterLabelTxt");
  if (narrowText != null) {
    narrowText.innerHTML = "Filter";
  }
  if (window._swat) {
    window._swat.initializeActionButtons("#kuResultListBlock");
  } else {
    window.SwymCallbacks = window.SwymCallbacks || [];

    window.SwymCallbacks.push(function () {
      window._swat.initializeActionButtons("#kuResultListBlock");
    });
  }
}

// Changes LUXE Pagination
klevu_helpers.luxePagination();
